export default "__VITE_ASSET__FYPxx6aO__"